import { render, staticRenderFns } from "./RelatorioConvenios.vue?vue&type=template&id=e85cdcf4&"
import script from "./RelatorioConvenios.vue?vue&type=script&lang=js&"
export * from "./RelatorioConvenios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports